// VanJS Feather - Zap
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Zap = (props: Partial<SVGProps> = {}) => {
  const { polygon } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    polygon({ points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" }),
  );
};
